import React from "react";
import { useSegmentList } from "./SegmentList.hooks";

const Context = React.createContext<ReturnType<typeof useSegmentList> | null>(
  null
);

export function useSegmentListView() {
  const contextValue = React.useContext(Context);
  if (!contextValue) {
    throw Error("Should be used inside the SegmentListProvider");
  }
  return contextValue;
}

export const SegmentListProvider = Context.Provider;
